import React from "react";
import { ReactElement } from "react";
import * as DashboardStore from '../../store/DashboardStore';
import { connect } from 'react-redux';
import { LoggedInUser } from "../../models/LoggedInUser";
import { PolicyInfo } from "../../models/PolicyInfo";

interface CutoverComingSoonProps {
    loggedInUser: LoggedInUser;
    policy: PolicyInfo;
    eligibleProgram: any;
}

interface CutoverComingSoonState {
    policy: PolicyInfo,
    eligibleProgram: any,
    selectedOption: string
}


export class CutoverComingSoon extends React.Component<any, CutoverComingSoonState> {
    constructor(props: CutoverComingSoonProps) {
        super(props);
        this.state = {
            policy: this.props.policy,
            eligibleProgram: this.props.eligibleProgram,
            selectedOption: ""
        };
    }

    async componentDidMount(): Promise<void> {
    }

    onClickBack(): void {
        let url = "";
            if (localStorage.getItem("returnUrl")) {
                let returnUrl = localStorage.getItem("returnUrl") || "";
                url = encodeURIComponent(returnUrl) || "/dashboard"
            }
            window.location.href = url;
    }
    
    render(): ReactElement {
        return (
            <>
                <div className="container cutover-container" id="cutover-container">
                    <div className="row cutover-header-row">
                        <div className="flexible-container cutover-coming-soon-container">
                                <div className="col-sm-1">
                                    <div className="cutover-coming-soon-icon icon-drive-easy"></div>
                                </div>
                                <div className="col-sm-11">
                                    <div className="cutover-coming-soon-header">DriveEasy Pro Coming Soon!</div>
                                    <div className="cutover-coming-soon-body">DriveEasy Pro is unavailable at this time, but check back later as we expand availability.</div>
                                    <div className="cutover-coming-soon-body row">If you need assistance, give us a call at <div className="cutover-phone-text">(866) 509-9444</div>.</div>
                                </div>
                            </div>
                    </div>
                    <div  className="row">
                        <div className="col-sm-12">
                            <button className="cutover-button-back-to-policy" onClick={() => this.onClickBack()}>Back To Policy Overview</button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => ({
    loggedInUser: state.loggedInUser,
    policy: state.dshs.policy,
    eligibleProgram: state.dshs.eligibleProgram,
});

export default connect(
    mapStateToProps,
    DashboardStore.actionCreators,
)(CutoverComingSoon as any);